// Flag Values
export const NOT_ENROLLED = 'not-enrolled';
export const CONTROL = 'control';
export const EXPERIMENT = 'experiment';
export const VAR1 = 'variation-1';
export const VAR2 = 'variation-2';
export const VAR3 = 'variation-3';
export const VAR4 = 'variation-4';
